import React from "react"
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from "react-share"
import icoTwitter from "../../images/ico-twitter.svg";
import icoLinkedin from "../../images/ico-linkedin.svg";
import icoFacebook from "../../images/ico-facebook.svg";

export default function SocialMediaButtons({
  url,
  title,
  summary,
  twitterVia,
  linkedInSource,
}) {
  return (
    <>
      <div className="socials pt-2 pb-2">
        <ul>
          <li>
            <TwitterShareButton url={url} title={title} via={twitterVia}>
              <img src={icoTwitter} alt="" />
            </TwitterShareButton>
          </li>

          <li>
            <LinkedinShareButton
              title={title}
              url={url}
              summary={summary}
              source={linkedInSource}
            >
              <img src={icoLinkedin} alt="" />
            </LinkedinShareButton>
          </li>
          <li>
            <FacebookShareButton url={url} quote={title}>
              <img src={icoFacebook} alt="" />
            </FacebookShareButton>
          </li>
        </ul>
      </div>
    </>
  )
}
